<div class="d-md-flex d-block border-bottom-gray">
  <h2 mat-dialog-title>{{ clientAccountId ? "Create " : "Update " }} Admin Detail</h2>
  <div class="text-end w-100">
  <button *ngIf="!isBulkUpload && !isEditUser && !data.isBulkUploadEdit" type="button" class="btn theme-btn px-3 ms-3" (click)="downloadFile()">
    <img class="me-2" src="../assets/images/document-upload.svg" alt=""/>Download Template
  </button>
  <input hidden type="file" accept=".xlsx, .xls, .csv" #uploadFileInput (change)="loadExcelData($event)" />
  <button *ngIf="!isBulkUpload && !isEditUser && !data.isBulkUploadEdit" type="button" class="btn theme-btn px-3 ms-3 mb-md-0 mb-2" (click)="bulkUpload()">
    <img
      class="me-2"
      src="../assets/images/document-upload.svg"
      alt="bulkupload"
    />Bulk Upload
  </button>
</div>
</div>
<button type="button" class="btn btn-link modal-close" (click)="closePopup()">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</button>

<div *ngIf="!isBulkUpload">
  <mat-dialog-content>
    <form [formGroup]="createMatAdminForm" class="">
      <div class="row">
        <div class="col-sm-6 mb-3">
          <span class="form-label">First Name</span>
          <input type="text" [required]="true" [readOnly]="!canEditUser" formControlName="firstName" class="form-control bg-zircon" [class.is-invalid]="
              createMatAdminForm.controls['firstName'].invalid &&
              createMatAdminForm.controls['firstName'].touched
            " />
          <div *ngIf="
              (createMatAdminForm.controls['firstName'].invalid &&
                createMatAdminForm.controls['firstName'].touched) ||
              createMatAdminForm.controls['firstName'].dirty
            ">
            <small *ngIf="createMatAdminForm.controls['firstName'].errors?.['required']" class="text-danger fs-13">First
              Name is required</small>
            <small *ngIf="createMatAdminForm.controls['firstName'].errors?.['pattern']" class="text-danger fs-13">Please
              provide a valid First Name</small>
          </div>
        </div>
        <div class="col-sm-6 mb-3">
          <span class="form-label">Last Name</span>
          <input type="text" [required]="true" [readOnly]="!canEditUser" formControlName="lastName" class="form-control bg-zircon" [class.is-invalid]="
              createMatAdminForm.controls['lastName'].invalid &&
              createMatAdminForm.controls['lastName'].touched
            " />
          <div *ngIf="
              (createMatAdminForm.controls['lastName'].invalid &&
                createMatAdminForm.controls['lastName'].touched) ||
              createMatAdminForm.controls['lastName'].dirty
            ">
            <small *ngIf="createMatAdminForm.controls['lastName'].errors?.['required']" class="text-danger fs-13">Last
              Name is required</small>
            <small *ngIf="createMatAdminForm.controls['lastName'].errors?.['pattern']" class="text-danger fs-13">Please
              provide a valid Last Name</small>
          </div>
        </div>
        <div class="col-sm-6 mb-0">
          <span class="form-label">Email Address</span>
          <input type="email" [required]="true" formControlName="email" class="form-control bg-zircon" [readOnly]="isEditUser"
            [class.is-invalid]="
              createMatAdminForm.controls['email'].invalid &&
              createMatAdminForm.controls['email'].touched
          " />
          <div *ngIf="
              (createMatAdminForm.controls['email'].invalid &&
                createMatAdminForm.controls['email'].touched) ||
              createMatAdminForm.controls['email'].dirty
            ">
            <small *ngIf="createMatAdminForm.controls['email'].errors?.['required']" class="text-danger fs-13">Email Address is
              required</small>
            <small *ngIf="createMatAdminForm.controls['email'].errors?.['pattern']" class="text-danger fs-13">Please
              provide a valid Email Address</small>
          </div>
        </div>
        <div class="col-sm-6 mb-0 contact-number editadmin-contactnumber">
          <span class="form-label">Contact Number</span>
          <mat-form-field class="w-100" appearance="outline" [class.is-invalid]="
              createMatAdminForm.controls['phoneNumber'].invalid &&
              createMatAdminForm.controls['phoneNumber'].touched
            ">
            <ngx-mat-intl-tel-input [enablePlaceholder]="true" [required]="true" [enableSearch]="true"
              formControlName="phoneNumber" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              [preferredCountries]="['gb']">
            </ngx-mat-intl-tel-input>
  
          </mat-form-field>
          <div class="custom-error-message" *ngIf="
            (createMatAdminForm.controls['phoneNumber'].invalid &&
              createMatAdminForm.controls['phoneNumber'].touched) ||
            createMatAdminForm.controls['phoneNumber'].dirty
          ">
            <small *ngIf="createMatAdminForm.controls['phoneNumber'].invalid" class="text-danger fs-13">Please provide a
              valid Contact Number</small>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-4">
            <div class="d-flex">
              <span class="black-text fs-14 mb-1">Upload</span>
              <mat-icon matTooltip="Attach documents related to MAT Admin" class="ms-2 fs-22">info</mat-icon>
            </div>
            <div class="mt-0 px-3 py-3 custom-file-input">
              <div class="file-input-wrapper">
                <span class="file-name">{{ selectedFileCount > 0 ? selectedFileCount + ' file(s) selected' : 'Click to upload' }}</span>
                <input hidden multiple type="file" #editMatAdminfileInput (change)="onFileSelected($event)" />
                <button class="btn theme-btn px-2 ms-3 border-sm-0" mat-raised-button color="primary"
                  (click)="uploadFromLocal($event)">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3 col-3 pe-2">
           <mat-slide-toggle 
           color="form-check-input" [(ngModel)]="this.isActive"
          [disabled]="true" labelPosition="before"
           aria-label="Set user active state">Active</mat-slide-toggle>
          </div>
          <div class="col-md-6 col-6 ps-2">
            <button type="button" class="btn theme-btn-outline w-100 pt-2" *ngIf="isEditUser" [disabled]="isAccountActivated || !isEditUser"
            (click)="resendActivation()" >
              Resend Activation
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-6 pe-2">
            <button type="button" class="btn theme-btn-outline w-100 pt-2" (click)="closePopup()">
              Cancel
            </button>
          </div>
          <div class="col-6 ps-2">
            <button type="button" class="btn theme-btn w-100 pt-2" (click)="createMatAdmin()"
              [disabled]="createMatAdminForm.invalid">
              {{ isEditUser || data.isBulkUploadEdit ? 'Update' : 'Create'}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</div>
<div *ngIf="isBulkUpload">
  <div
    class="table-responsive tab-table account-admin-header create-admin-table">
    <table
      aria-describedby="This table describes the account admin information"
      class="table table-hover"
    >
      <thead>
        <tr>
          <th class="firstName-header">
            First Name
          </th>
          <th class="lastName-header">
            Last Name
          </th>
          <th class="email-header">
            Email Address
          </th>
          <th class="contactNumber-header">Country Code</th>
          <th class="contactNumber-header">Contact Number</th>
          <th class="action-header sticky-right">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let detail of excelData; let i = index">
          <td><p class="mat-account-detail mb-0">{{ detail.firstName }}</p></td>
          <td><p class="mat-account-detail mb-0">{{ detail.lastName }}</p></td>
          <td>
            <p #matAccountDetail class="mat-account-detail mb-0">{{ detail.emailId }}</p>
          </td>
          <td>{{ detail.countryCode }}</td>
          <td>{{ detail.phoneNumber }}</td>
          <td class="sticky-right">
            <ng-container>
              <a class="btn-action" (click)="openEditMatAdminDialog(detail, i)" matTooltip="Edit details">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1333C3.23329 15.1083 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                    stroke="#4F6681"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.90845 4.20837C10.2668 6.50837 12.1334 8.26671 14.4501 8.50004"
                    stroke="#4F6681"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.5 18.3334H17.5"
                    stroke="#4F6681"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <a (click)="deleteItem(i)" class="btn-action" matTooltip="Delete details">
              <svg width="16" height="16"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.4999 1.5C10.9141 1.5 11.2499 1.16421 11.2499 0.75C11.2499 0.335787 10.9141 0 10.4999 0H5.49992C5.0857 0 4.74992 0.335786 4.74992 0.75C4.74992 1.16421 5.0857 1.5 5.49992 1.5L10.4999 1.5ZM1.33325 3.58333H1.44226L2.13845 13.0111L2.13849 13.0117C2.23268 14.2735 3.28338 15.25 4.54891 15.25H11.4489C12.7167 15.25 13.7689 14.2699 13.8595 13.0053L13.8595 13.0051L14.5323 3.58333H14.6666C15.0808 3.58333 15.4166 3.24755 15.4166 2.83333C15.4166 2.41912 15.0808 2.08333 14.6666 2.08333H13.8351L13.8339 2.08333H2.13891L2.13826 2.08333H1.33325C0.919038 2.08333 0.583252 2.41912 0.583252 2.83333C0.583252 3.24755 0.919038 3.58333 1.33325 3.58333ZM3.63433 12.9L2.94634 3.58333H13.0285L12.3633 12.8981C12.3289 13.3784 11.9294 13.75 11.4489 13.75H4.54891C4.06954 13.75 3.6703 13.38 3.63435 12.9003L3.63433 12.9ZM10.4166 7C10.4166 6.58579 10.0808 6.25 9.66658 6.25C9.25237 6.25 8.91658 6.58579 8.91658 7V10.3333C8.91658 10.7475 9.25237 11.0833 9.66658 11.0833C10.0808 11.0833 10.4166 10.7475 10.4166 10.3333V7ZM6.74992 6.25C7.16413 6.25 7.49992 6.58579 7.49992 7V10.3333C7.49992 10.7475 7.16413 11.0833 6.74992 11.0833C6.3357 11.0833 5.99992 10.7475 5.99992 10.3333V7C5.99992 6.58579 6.3357 6.25 6.74992 6.25Z"
                  fill="#4F6681" />
              </svg>
            </a>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>   
  </div>
  <div class="d-flex justify-content-end">
    <div class="px-2">
      <button
        type="button"
        class="btn theme-btn-outline pt-2 px-2 px-md-5"
        (click)="closePopup()">
        Cancel
      </button>
    </div>
    <div class="px-2">
      <button type="button" (click)="createBulkUsers()" class="btn theme-btn pt-2 px-2 px-md-5" [disabled]="!areAllDetailsFilled()">Create</button>
    </div>
  </div>
</div>
